import React from 'react'
import map from 'lodash/map'
import InteractiveContentBlocks from '../../../core/components/interactive-content-blocks/InteractiveContentBlocks'
import VisibleStreakMeter from '../containers/VisibleStreakMeter'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {PrimaryButton, SecondaryButton, TertiaryButtonDark, UniLink} from '../../../core/components/unilink/index'
import './grandmasterProblem.css'

const GrandmasterProblem = ({problem, baseTopicId, hasInputAnswer, submitAnswerGrandmaster, nextProblem, batchHasPosted, revealSolutionGrandmaster, viewExplanations, openShare, toggleVote, report}) => {
  if (problem) {
    const {authors, voteCount, type, renderedContent, id, currentUserHasVoted} = problem
    const authorString = map(authors, (a,index)=>{
      if (index === 0) return (
        <UniLink
          key={a.id}
          to={`/user/${a.id}`}>
          {a.displayName}
        </UniLink>)
      if (index === 1) return ' et al'
      else return null
    })
    const askBlockIndex = renderedContent.length-1
    const {isCorrect, shouldContinue, hasSubmitted} = renderedContent[askBlockIndex].content

    const footClassNames = ['grandmaster-interactive-content__foot']
    if (isCorrect) {
      footClassNames.push('grandmaster-interactive-content__foot--correct')
    }

    return (
      <div className='grandmaster-problem-container'>
        <div className='grandmaster-problem__streak-container'>
          <VisibleStreakMeter />
        </div>
        <div className='grandmaster-interactive-content'>
          <InteractiveContentBlocks
            type={type}
            content={renderedContent}
            disabled={shouldContinue}
            as='grandmasterProblem'
          />
          <div className='grandmaster-interactive__actions'>
            <div className='grandmaster-interactive__feedback'>
              {
                isCorrect && hasSubmitted
                  ? <span><b>Correct! </b> Check out solutions below or click next.</span>
                  : !isCorrect && hasSubmitted
                    ? <span><b>Incorrect! </b>Try Help or <UniLink onClick={()=>revealSolutionGrandmaster(askBlockIndex)}>View Answer</UniLink>.</span>
                    : null
              }
            </div>
            <div className='grandmaster-interactive__buttons'>
              <TertiaryButtonDark
                className='grandmaster-interactive__help'
                onClick={viewExplanations}
                disabled={shouldContinue}>Review Topic</TertiaryButtonDark>
              {
                !hasSubmitted && !batchHasPosted
                  ? <PrimaryButton
                    onClick={()=>submitAnswerGrandmaster(askBlockIndex)}
                    className='grandmaster-interactive__check'
                    disabled={!hasInputAnswer}>
                    Check
                  </PrimaryButton>
                  : hasSubmitted && !isCorrect && !batchHasPosted
                    ? <SecondaryButton
                      onClick={()=>submitAnswerGrandmaster(askBlockIndex)}
                      className='grandmaster-interactive__check'>
                    Try Again
                    </SecondaryButton>
                    : <PrimaryButton
                      onClick={()=>nextProblem(baseTopicId)}
                      className='grandmaster-interactive__check'>
                    Next
                    </PrimaryButton>
              }

            </div>
          </div>
          <div className={footClassNames.join(' ')}>
            <div className='grandmaster-interactive-content__authors'>
              <div>
                Problem by {authorString}
              </div>
            </div>
            <div className='grandmaster-interactive-content__bottom'>
              <UniLink
                onClick={()=>{
                  toggleVote(type, id)
                }}
                className='grandmaster-interactive-content__votes'>
                { currentUserHasVoted ? <FontAwesomeIcon icon={['fa', 'heart']} /> : <FontAwesomeIcon icon={['far', 'heart']} /> } {voteCount}
              </UniLink>
              <div className='grandmaster-interactive-content__share-report'>
                <UniLink
                  className='grandmaster-interactive-content__share'
                  onClick={()=>openShare(baseTopicId, id, type)}>
                  <FontAwesomeIcon icon={['fa', 'share-alt']} /> Share
                </UniLink>
                <UniLink
                  onClick={()=>report(problem)}><FontAwesomeIcon icon={['fa', 'exclamation-circle']} /> Report</UniLink>
              </div>
            </div>
          </div>
        </div>
      </div>

    )
  }
  return null
}

export default GrandmasterProblem



// WEBPACK FOOTER //
// ./src/domains/grandmaster/components/GrandmasterProblem.js